module.exports = __webpack_public_path__ + "img/camera-arrow.4b7aa91a.svg";